import axios from 'axios';
import Auth from '../lib/auth';
import utilsLib from './utils.lib';
import {addNotification} from "./notifications";

export const GET_PRODUCTS_REQUEST = 'GET_PRODUCTS_REQUEST';
export const GET_PRODUCTS_SUCCESS = 'GET_PRODUCTS_SUCCESS';
export const GET_PRODUCTS_ERROR = 'GET_PRODUCTS_ERROR';

export const GET_PRODUCT_REQUEST = 'GET_PRODUCT_REQUEST';
export const GET_PRODUCT_SUCCESS = 'GET_PRODUCT_SUCCESS';
export const GET_PRODUCT_ERROR = 'GET_PRODUCT_ERROR';

export const CREATE_PRODUCT_REQUEST = 'CREATE_PRODUCT_REQUEST';
export const CREATE_PRODUCT_SUCCESS = 'CREATE_PRODUCT_SUCCESS';
export const CREATE_PRODUCT_ERROR = 'CREATE_PRODUCT_ERROR';

export const UPDATE_PRODUCT_REQUEST = 'UPDATE_PRODUCT_REQUEST';
export const UPDATE_PRODUCT_SUCCESS = 'UPDATE_PRODUCT_SUCCESS';
export const UPDATE_PRODUCT_ERROR = 'UPDATE_PRODUCT_ERROR';

export const CHANGE_STATUS_PRODUCT_REQUEST = 'CHANGE_STATUS_PRODUCT_REQUEST';
export const CHANGE_STATUS_PRODUCT_SUCCESS = 'CHANGE_STATUS_PRODUCT_SUCCESS';
export const CHANGE_STATUS_PRODUCT_ERROR = 'CHANGE_STATUS_PRODUCT_ERROR';

export const DELETE_PRODUCT_REQUEST = 'DELETE_PRODUCT_REQUEST';
export const DELETE_PRODUCT_SUCCESS = 'DELETE_PRODUCT_SUCCESS';
export const DELETE_PRODUCT_ERROR = 'DELETE_PRODUCT_ERROR';

export const CLEAN_PRODUCTS = 'CLEAN_PRODUCTS';

// Get products
export function getProducts(query) {
    return async (dispatch) => {
        try {
            dispatch(getProductsRequest());

            const token = Auth.getLocalJwt();
            const res = await axios.post('/api/products/query', query, { headers: { 'Authorization': 'Bearer ' + token } });

            dispatch(utilsLib.response(res, getProductsSuccess, getProductsError));
        } catch (err) {
            dispatch(utilsLib.response(err, getProductsError));
        }
    };
};

function getProductsRequest() {
    return {
        type: GET_PRODUCTS_REQUEST,
        isFetching: true
    };
}

function getProductsSuccess (payload) {
    return {
        type: GET_PRODUCTS_SUCCESS,
        isFetching: false,
        error: false,
        payload
    };
}

function getProductsError(errorMessage) {
    return {
        type: GET_PRODUCTS_ERROR,
        isFetching: false,
        error: true,
        errorMessage
    };
}

// Get product
export function getProduct(productId, options) {

    return async (dispatch) => {
        try {
            dispatch(getProductRequest());
            const token = Auth.getLocalJwt();
            const res = await axios.post(`/api/products/${productId}`, options, { headers: { 'Authorization': 'Bearer ' + token } });

            dispatch(utilsLib.response(res, getProductSuccess, getProductError));
        } catch (err) {
            dispatch(utilsLib.response(err, getProductError));
        }
    };
};

function getProductRequest() {
    return {
        type: GET_PRODUCT_REQUEST,
        isFetching: true
    };
}

function getProductSuccess (payload) {
    return {
        type: GET_PRODUCT_SUCCESS,
        isFetching: false,
        error: false,
        payload
    };
}

function getProductError(errorMessage) {
    return {
        type: GET_PRODUCT_ERROR,
        isFetching: false,
        error: true,
        errorMessage
    };
}

// Create product
export function createProduct(product) {
    return async (dispatch) => {
        try {
            dispatch(createProductRequest());

            const token = Auth.getLocalJwt();
            const res = await axios.post('/api/products', product, { headers: { 'Authorization': 'Bearer ' + token } });

            dispatch(utilsLib.response(res, createProductSuccess, createProductError));
        } catch (err) {
            dispatch(utilsLib.response(err, createProductError));
        }
    };
};

function createProductRequest() {
    return {
        type: CREATE_PRODUCT_REQUEST,
        isFetching: true
    };
}

function createProductSuccess (payload) {
    return dispatch => {
        // Create notification for create product success
        dispatch(addNotification({
            message: 'Producto creado correctamente',
            color: 'green',
            icon: 'tick'
        }));
        dispatch({
            type: CREATE_PRODUCT_SUCCESS,
            isFetching: false,
            error: false,
            payload
        });
    }
}

function createProductError(errorMessage) {
    return dispatch => {
        // Create notification for create product error
        dispatch(addNotification({
            message: 'Error al crear el producto',
            color: 'red',
            icon: 'warning-sign'
        }));
        dispatch({
            type: CREATE_PRODUCT_ERROR,
            isFetching: false,
            error: true,
            errorMessage
        });
    }
}

// Update product
export function updateProduct(productId, product = {}) {
    return async (dispatch) => {
        try {
            dispatch(updateProductRequest());
            const token = Auth.getLocalJwt();
            const res = await axios.put(`/api/products/${productId}`, product, { headers: { 'Authorization': 'Bearer ' + token } });

            dispatch(utilsLib.response(res, updateProductSuccess, updateProductError));
        } catch (err) {
            dispatch(utilsLib.response(err, updateProductError));
        }
    };
};

function updateProductRequest() {
    return {
        type: UPDATE_PRODUCT_REQUEST,
        isFetching: true
    };
}

function updateProductSuccess (payload) {
    return dispatch => {
        // Create notification for update product success
        dispatch(addNotification({
            message: 'Producto actualizado correctamente',
            color: 'green',
            icon: 'tick'
        }));
        dispatch({
            type: UPDATE_PRODUCT_SUCCESS,
            isFetching: false,
            error: false,
            payload
        });
    }
}

function updateProductError(errorMessage) {
    return dispatch => {
        // Create notification for update product error
        dispatch(addNotification({
            message: 'Error al actualizar el producto',
            color: 'red',
            icon: 'warning-sign'
        }));
        dispatch({
            type: UPDATE_PRODUCT_ERROR,
            isFetching: false,
            error: true,
            errorMessage
        });
    }
}

// Change product status
export function changeProductStatus(productId, status) {
    return async (dispatch) => {
        try {
            dispatch(changeProductStatusRequest());

            const token = Auth.getLocalJwt();
            const res = await axios.put(`/api/products/${productId}/status`, { status }, { headers: { 'Authorization': 'Bearer ' + token } });

            dispatch(utilsLib.response(res, changeProductStatusSuccess, changeProductStatusError));
        } catch (err) {
            dispatch(utilsLib.response(err, changeProductStatusError));
        }
    };
};

function changeProductStatusRequest() {
    return {
        type: CHANGE_STATUS_PRODUCT_REQUEST,
        isFetching: true
    };
}

function changeProductStatusSuccess (payload) {
    return dispatch => {
        // Create notification for update status success
        dispatch(addNotification({
            message: 'Estado actualizado correctamente',
            color: 'green',
            icon: 'tick'
        }));
        dispatch({
            type: CHANGE_STATUS_PRODUCT_SUCCESS,
            isFetching: false,
            error: false,
            payload
        });
    }
}

function changeProductStatusError(errorMessage) {
    return dispatch => {
        // Create notification for update status error
        dispatch(addNotification({
            message: 'Error al actualizar el estado',
            color: 'red',
            icon: 'warning-sign'
        }));
        dispatch({
            type: CHANGE_STATUS_PRODUCT_ERROR,
            isFetching: false,
            error: true,
            errorMessage
        });
    }
}

// Delete product
export function deleteProduct(productId) {

    return async (dispatch) => {
        try {
            dispatch(deleteProductRequest());
            const token = Auth.getLocalJwt();
            const res = await axios.delete(`/api/products/${productId}`, { headers: { 'Authorization': 'Bearer ' + token } });

            dispatch(utilsLib.response(res, deleteProductSuccess, deleteProductError));
        } catch (err) {
            dispatch(utilsLib.response(err, deleteProductError));
        }
    };
}

function deleteProductRequest() {
    return {
        type: DELETE_PRODUCT_REQUEST,
        isFetching: true
    };
}

function deleteProductSuccess (payload) {
    return dispatch => {
        // Create notification for delete customer success
        dispatch(addNotification({
            message: 'Producto eliminado correctamente',
            color: 'green',
            icon: 'tick'
        }));
        dispatch({
            type: DELETE_PRODUCT_SUCCESS,
            isFetching: false,
            error: false,
            payload
        });
    }
}

function deleteProductError(errorMessage) {
    return dispatch => {
        // Create notification for delete customer error
        dispatch(addNotification({
            message: 'Error al eliminar el producto',
            color: 'red',
            icon: 'warning-sign'
        }));
        dispatch({
            type: DELETE_PRODUCT_ERROR,
            isFetching: false,
            error: true,
            errorMessage
        });
    }
}

export function cleanProducts() {
    return {
        type: 'CLEAN_PRODUCTS',
        isFetching: false,
        error: false,
        payload: []
    }
}


// WEBPACK FOOTER //
// ./src/actions/products.js